import React from 'react'
import PropTypes from 'prop-types'

import { logOut } from 'utils/auth'
import Button from 'components/Button'
import RevenueCentersList from 'components/RevenueCentersList'
import Version from 'components/Version'

const RevenueCenters = ({ revenueCenters, signOut }) => {
  const handleLogOut = () => {
    signOut()
    logOut()
  }

  return (
    <section className="revenue-centers">
      <header>
        <h3 className="revenue-centers__header">Revenue Centers:</h3>
        <Version />
      </header>
      <RevenueCentersList revenueCenters={revenueCenters} />
      <Button onClick={handleLogOut} title="Sign out" />
    </section>
  )
}

RevenueCenters.propTypes = {
  revenueCenters: PropTypes.array,
  signOut: PropTypes.func,
}

export default RevenueCenters
